"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiConnector = _interopRequireDefault(require("../ApiConnector"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Check all required options.
 * @param {Object} options
 * @return {Array}
 */
var checkOptions = function checkOptions(options) {
  var requiredFields = [];
  return requiredFields.filter(function (field) {
    return !options[field];
  });
};

var plugin = function plugin(Vue, options) {
  if (plugin.installed) {
    return;
  }

  plugin.installed = true;
  var missingOptions = checkOptions(options);

  if (missingOptions.length > 0) {
    throw new Error('[SERVICES] Missing options: ' + missingOptions.join(', '));
  }

  var instance = null;
  Object.defineProperty(Vue.prototype, '$services', {
    get: function get() {
      if (!instance) {
        instance = _ApiConnector["default"].getInstance(options.host, options.version, options.mandant, options.trainingCenterId, options.modules);
        instance.setObtainToken(options.obtainTokenMethod);
        instance.setRemoveToken(options.removeTokenMethod);
        instance.setToken(options.tokenMethod);
      }

      return instance;
    }
  });
};

var _default = plugin;
exports["default"] = _default;